import {
  getPaginationFilterParamsFromGridState,
  stringToBase64,
} from "../shared/utility";
import { getTcgRequest, putRequest } from "../system/serverCall";
import {
  deleteRequestWithData,
  getRequest,
  postRequest,
  pricechartingApiRequest,
  scryfallApiRequest,
} from "../system/serverCall";
import serverResponseHandler from "../system/serverResponseHandler";
import {
  GET_INVENTORY_MISC_INFO_TYPES,
  FALSE_STRING,
  EMPTY_STRING,
} from "../constants";

const pricechartingBaseUrl = process.env.REACT_APP_PRICECHARTING_BASE_URL;
const scryfallBaseUrl = process.env.REACT_APP_SCRYFALL_BASE_URL;
const priceChartingApiKey = process.env.REACT_APP_PRICECHARTING_API_KEY;

//-------Get Store Details from server
const getAllInventory = (storeId) => {
  return getRequest(`inventory-store/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStoreCustomProducts = (storeId) => {
  return getRequest(
    `inventory/?store=${storeId}&isStoreCustomProducts=true`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------update inventory
const updateInventory = (storeId, data, isAddShrinkTracking = false) => {
  return putRequest(
    `inventory?store=${storeId}&isAddShrinkTracking=${isAddShrinkTracking}`,
    data
  ).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
//-------qualityShrink inventory
const quantityShrink = (data) => {
  return postRequest(`shrink-tracking`, data).then(
    (response) => response,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const getInventoryHistory = (storeId, type, startDate, endDate, cat) => {
  return getRequest(
    `transaction-history/${storeId}?type=${type}&startDate=${startDate}&endDate=${endDate}${
      cat ? `&category=${cat}` : ""
    }`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Store Inventory summary
const getStoreInventorySummary = (storeId) => {
  return getRequest(`inventory-summary-store/${storeId}`, true).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Store Inventory summary
const deleteInventory = (data, storeId, isAddShrinkTracking = false) => {
  return deleteRequestWithData(
    `inventory?store=${storeId}&isAddShrinkTracking=${isAddShrinkTracking}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Product data search from priceCharting Api
const getPricechartingApiProducts = (queryData) => {
  return pricechartingApiRequest(
    `${
      process.env.REACT_APP_IS_PRICECHARTING === FALSE_STRING
        ? process.env.REACT_APP_BASE_URL + "system-products"
        : pricechartingBaseUrl + "products"
    }?t=${priceChartingApiKey}&q=${queryData}`
  ).then(
    (response) => response?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Product data search from priceCharting Api
const getPricechartingProductById = (id) => {
  return pricechartingApiRequest(
    `${
      process.env.REACT_APP_IS_PRICECHARTING === FALSE_STRING
        ? process.env.REACT_APP_BASE_URL + "system-products"
        : pricechartingBaseUrl + "product"
    }?t=${priceChartingApiKey}&id=${id}`
  ).then(
    (response) => response?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getInventoryByPricechartingId = (storeId, data) => {
  return postRequest(
    `inventory-by-misc-info/${storeId}?requestType=${GET_INVENTORY_MISC_INFO_TYPES.GET_PRODUCTS_BY_PRICECHARTING_ID}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getInventoryByProductMetaData = (storeId, data) => {
  return postRequest(
    `inventory-by-misc-info/${storeId}?requestType=${GET_INVENTORY_MISC_INFO_TYPES.GET_PRODUCTS_BY_META_DATA}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getSkuNumber = (storeId) => {
  return getRequest(`get-sku/${storeId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getTags = (storeId) => {
  return getRequest(`tags/${storeId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const addDefaultTags = (storeId, data) => {
  return postRequest(`tags/${storeId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Product data search from priceCharting Api
const getscryfallApiProducts = (queryData) => {
  return scryfallApiRequest(
    `${scryfallBaseUrl}cards/search?q=${queryData}&unique=prints`
  ).then(
    (response) => response?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
//-------Get Product data search from priceCharting Api
const getscryfallApiProductById = (cardId) => {
  return scryfallApiRequest(`${scryfallBaseUrl}cards/${cardId}`).then(
    (response) => response?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Get Product data search from tcgPlayer Api
const getTcgPlayerApiProducts = (queryData) => {
  const tcgPlayerBaseUrl = process.env.REACT_APP_TCG_PLAYER_URL;
  return getTcgRequest(
    `${tcgPlayerBaseUrl}?search=${queryData.searchValue}&category=${queryData.category}&pageNumber=1&pageSize=500`
  ).then(
    (response) => response?.data?.data?.products ?? [],
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getTcgPlayerProductById = (id) => {
  const tcgPlayerBaseUrl = process.env.REACT_APP_TCG_PLAYER_URL;
  return getTcgRequest(
    `${tcgPlayerBaseUrl}?id=${id}&pageNumber=1&pageSize=500`
  ).then(
    (response) => response?.data?.data?.products?.[0] ?? {},
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const handleTransferCompanyInventory = (data) => {
  return postRequest(`inventory-transfer`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const addBatchInventory = (data) => {
  return postRequest(`inventory-batch/${data[0].store.id}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const addBatchInventoryDraft = (data) => {
  return postRequest(
    `inventory-batch/${data?.store?.id}/?isInventoryDraft=true`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const importFileInventory = (data) => {
  if (data.length) {
    return postRequest(
      `inventory-batch/${data[0].store.id}?isImportApiCall=true`,
      data
    ).then(
      (response) => response?.data?.data,
      (error) => serverResponseHandler.handleHTTPResponses(error.response)
    );
  } else {
    // if no valid inventory

    return new Promise((resolve, reject) => {
      const data = {
        reqInvalidInventory: [],
        updatedInventory: [],
      };
      // You can perform asynchronous operations here if needed
      // Once your asynchronous operations are done, you can resolve the Promise
      resolve(data);
    });
  }
};

const addPriceChangeThreshold = (data) => {
  return postRequest(`threshold/${data.store.id}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getPriceChangeThreshold = (storeId) => {
  return getRequest(`threshold/${storeId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getPriceChanges = (storeId) => {
  return getRequest(`price-changes/${storeId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const dismissProduct = (storeId, data) => {
  return putRequest(`price-changes/${storeId}?isDismissUpdate=true`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};
const handleThresholdCsvData = (storeId) => {
  return postRequest(`price-changes/${storeId}`, null).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updatePriceChangeProductPrices = (storeId, data) => {
  return putRequest(`inventory-batch/${storeId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const removeProductFromPriceChanges = (storeId, data) => {
  return putRequest(`price-changes/${storeId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getPricechartingProductImage = (data) => {
  return postRequest(
    `inventory-by-misc-info/null?requestType=${GET_INVENTORY_MISC_INFO_TYPES.GET_PRODUCT_IMAGE_URL}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getPaginatedInventoryHistory = (storeId, gridState) => {
  return getRequest(
    `transaction-history/${storeId}?search=${
      gridState.searchQuery
    }&pageNumber=${gridState.pageIndex}&pageSize=${
      gridState.pageSize
    }&filters=${stringToBase64(gridState.filters)}&sortFilter=${stringToBase64(
      gridState.sortFilter
    )}`,
    true
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getPaginatedInventory = (storeId, gridState, isPriceChangesApiCall) => {
  return getRequest(
    `inventory-serverside/${storeId}/?${
      isPriceChangesApiCall ? "isPriceChangesApiCall=true&" : ""
    }${getPaginationFilterParamsFromGridState(gridState)}`
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getCompanyInventory = (companyId, gridState) => {
  return getRequest(
    `company-inventory-serverside/${companyId}?${getPaginationFilterParamsFromGridState(
      gridState
    )}`
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStoreCustomProductsByName = (storeId, data) => {
  return postRequest(
    `inventory-by-misc-info/${storeId}?requestType=${GET_INVENTORY_MISC_INFO_TYPES.GET_CUSTOM_PRODUCTS_BY_NAME}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const startNewAuditSession = (storeId, data) => {
  return postRequest(`stock-audit/${storeId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateAuditSession = (storeId, data) => {
  return putRequest(`stock-audit/${storeId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getPaginatedStockAudit = (storeId, gridState, timeFrame) => {
  return getRequest(
    `stock-audit/${storeId}/?${getPaginationFilterParamsFromGridState(
      gridState
    )}&startDate=${timeFrame.start}&endDate=${timeFrame.end}`
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStockAuditCategories = (storeId, auditId) => {
  return getRequest(`stock-audit-categories/${storeId}/${auditId}`).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getStockAuditBreakdown = (
  storeId,
  auditId,
  breakdownBy,
  gridState,
  { selectedProductType, selectedCategory, selectedSubCategory } = {}
) => {
  const normalizedGridState = {
    searchQuery: EMPTY_STRING,
    pageSize: 50,
    pageIndex: 0,
    filters: EMPTY_STRING,
    sortFilter: EMPTY_STRING,
    ...(gridState || {}),
  };

  const encodedSearchQuery = normalizedGridState.searchQuery
    ? encodeURIComponent(String(normalizedGridState.searchQuery))
    : EMPTY_STRING;

  const query =
    `${getPaginationFilterParamsFromGridState({
      ...normalizedGridState,
      searchQuery: encodedSearchQuery,
    })}` +
    `${encodedSearchQuery ? `&searchQuery=${encodedSearchQuery}` : ""}` +
    `&breakdownBy=${breakdownBy}` +
    `${
      selectedProductType ? `&selectedProductType=${selectedProductType}` : ""
    }` +
    `${selectedCategory ? `&selectedCategory=${selectedCategory}` : ""}` +
    `${
      selectedSubCategory ? `&selectedSubCategory=${selectedSubCategory}` : ""
    }`;

  return getRequest(
    `stock-audit-breakdown/${storeId}/${auditId}?${query}`
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateStockAuditBreakdown = (storeId, auditId, data) => {
  return putRequest(`stock-audit-breakdown/${storeId}/${auditId}`, data).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateStockAuditCategory = (storeId, auditId, data, operation) => {
  return putRequest(
    `stock-audit-categories/${storeId}/${auditId}?operation=${operation}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const getAuditInventory = (
  storeId,
  auditId,
  categoryName,
  productTypeName,
  gridState,
  isScanned = false
) => {
  return getRequest(
    `stock-audit-inventory/${storeId}/${auditId}/${categoryName}/${productTypeName}/?${getPaginationFilterParamsFromGridState(
      gridState
    )}&isScanned=${isScanned}`
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

const updateAuditInventory = (
  storeId,
  auditId,
  categoryName,
  productTypeName,
  data,
  operation
) => {
  return putRequest(
    `stock-audit-inventory/${storeId}/${auditId}/${categoryName}/${productTypeName}?operation=${operation}`,
    data
  ).then(
    (response) => response?.data?.data,
    (error) => serverResponseHandler.handleHTTPResponses(error.response)
  );
};

//-------Export inventory Services
export const inventoryService = {
  getTags,
  getSkuNumber,
  addDefaultTags,
  dismissProduct,
  quantityShrink,
  getAllInventory,
  updateInventory,
  getPriceChanges,
  deleteInventory,
  addBatchInventory,
  getCompanyInventory,
  getInventoryHistory,
  importFileInventory,
  getPaginatedInventory,
  getPaginatedStockAudit,
  startNewAuditSession,
  handleThresholdCsvData,
  getscryfallApiProducts,
  getStoreCustomProducts,
  addBatchInventoryDraft,
  getStockAuditCategories,
  getStockAuditBreakdown,
  updateStockAuditBreakdown,
  updateStockAuditCategory,
  getAuditInventory,
  updateAuditInventory,
  updateAuditSession,
  getPriceChangeThreshold,
  getTcgPlayerApiProducts,
  getTcgPlayerProductById,
  addPriceChangeThreshold,
  getStoreInventorySummary,
  getscryfallApiProductById,
  getPricechartingApiProducts,
  getPricechartingProductById,
  getPaginatedInventoryHistory,
  getStoreCustomProductsByName,
  getPricechartingProductImage,
  removeProductFromPriceChanges,
  getInventoryByProductMetaData,
  getInventoryByPricechartingId,
  updatePriceChangeProductPrices,
  handleTransferCompanyInventory,
};
